/* eslint-disable no-alert */
// CustomDatePicker.js

import React, { useState, useRef, useEffect } from 'react';
import './CustomDatePicker.scss';


const formatDate = (date) => {
  const d = new Date(date);
  const day = d.getUTCDate().toString().padStart(2, '0');
  const month = (d.getUTCMonth() + 1).toString().padStart(2, '0');
  const year = d.getUTCFullYear();
  return `${day} / ${month} / ${year}`;
};

const CustomDatePicker = ({ 
  field = {},
  form = {},
  label = '',
  maxLength=80,
  inputClassName='',
  change = () => {},
  blur = () => {},
  value = '',
  ...props 
}) => {
  const [visibleSelectedDate, setVisibleSelectedDate] = useState(''); // Se usa para mostrar la fecha en el input de tipo text
  const [selectedDate, setSelectedDate] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    if(field.value && field.value!==''){
      setVisibleSelectedDate(formatDate(field.value));
      setSelectedDate(field.value);
    }else if(value && value!==''){
      setVisibleSelectedDate(formatDate(value));
      setSelectedDate(value);
    }
  }, [field.value, value]);

  const handleIconClick = () => {
    // Simula un clic en el input de tipo date al hacer clic en el icono
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  const handleChange = (e) => {
    if(form && form.setFieldValue){
      form.setFieldValue(field.name, e.target.value);
    }else{
      setVisibleSelectedDate(formatDate(e.target.value));
      change(e);
      blur();
    }
    setSelectedDate(e.target.value);    
  };

  return (
    <div className="CustomDatePicker">
      <div className="input-group has-validation">
        {label && (<label htmlFor="custom-date" className="form-label col-form-label col-12 text-left">{label}</label>)}
        <div className={(inputClassName && inputClassName!=='')?inputClassName:'col-12'}>
          <input
            type="text"
            className='form-control border-0 custom-input-border-bottom'
            placeholder="dd / mm / aaaa"
            {...field}
            {...props}
            value={visibleSelectedDate}
            readOnly
          />
          <span className="icon" onClick={handleIconClick}>
            <i className="fa fa-calendar-o" style={{ position: 'absolute', cursor: 'pointer'}} onClick={handleIconClick} />
          </span>
          <input
            type="date"
            ref={inputRef}
            className="hidden-input"
            onChange={handleChange}
            maxLength={maxLength}
            value={selectedDate}
            onClick={handleIconClick}
            {...field}
            {...props}
          />
        </div>        
      </div>
    </div>
  );
};

export default CustomDatePicker;